/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from 'react';

// @mui material components
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDBadgeDot from 'components/MDBadgeDot';

// Material Dashboard 2 PRO React examples
import PieChart from 'examples/Charts/PieChart';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';
import { useSelector } from 'react-redux';

// Material Dashboard 2 PRO React examples
import Navbar from 'examples/Navbars/NavBar';
import {
  Backdrop,
  CardContent,
  CircularProgress,
  Icon,
  InputAdornment,
  MenuItem,
} from '@mui/material';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import MDDateRange from 'components/MDDateRange';

const initFind = {
  period: 'DATE',
  branch: 0,
  date_start: Func.dateTimeFirstMonth(),
  date_stop: Func.dateTimeEndMonth(),
};

const initChart = {
  title: '',
  description: '',
  date: '',
  chart: {
    labels: [],
    datasets: [],
  },
};

function DashboardSaleProfit() {
  const mod = 'dashboard_sale_profit';
  const { t, i18n } = useTranslation();
  const app = useSelector((state) => state[APP_STATE]);
  const [chartPie, setChartPie] = useState(initChart);
  const [cboBranch, setCboBranch] = useState([]);
  const [find, setFind] = useState(initFind);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(chartPie);
  }, [chartPie]);

  const view = (data) => {
    setFind(data);
    setLoading(true);

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      branch: data.branch,
      period: data.period,
      date_start: data.date_start,
      date_stop: data.date_stop,
    }).then((result) => {
      if (result.status === 'ok') {
        setChartPie(result.pie);
      }
      setLoading(false);
    });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setCboBranch(result.branch);

        view(initFind);
      } else {
        Func.exitApp();
      }
    });
  };

  const setDateRange = (start, stop) => {
    view({
      ...find,
      date_start: Func.dateTimeFormat(start.toDate()),
      date_stop: Func.dateTimeFormat(stop.toDate()),
    });
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={5} lg={5} xl={3}>
            <MDInput
              fullWidth
              value={find.branch}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, branch: e.target.value })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.branch')} :</InputAdornment>
                ),
              }}
            >
              {cboBranch.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          {find.period === 'ALL' ? (
            <Grid item xs={12} sm={12} md={3} lg={3} xl={2}>
              <MDButton
                variant='outlined'
                color='secondary'
                fullWidth
                sx={{ p: 1.5 }}
                onClick={() => view({ ...find, period: 'DATE' })}
              >
                <Icon>edit_calendar</Icon>&nbsp;เลือกช่วงเวลา
              </MDButton>
            </Grid>
          ) : null}
          {find.period === 'ALL' ? null : (
            <Grid item xs={12} sm={12} md={7} lg={7} xl={4}>
              <MDDateRange
                dateStart={find.date_start}
                dateStop={find.date_stop}
                callBack={setDateRange}
                closeDate={() => view({ ...find, period: 'ALL' })}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderChart = () => {
    return (
      <MDBox mb={3} mt={1}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <Card sx={{ height: '100%' }}>
              <MDBox py={3} pr={2} pl={3}>
                <MDBox>
                  <MDTypography variant='h6'>
                    {chartPie.chart.labels.length ? 'กำไรขายของสาขาแยกหมวดหมู่' : 'กรุณาเลือกสาขา'}
                  </MDTypography>
                </MDBox>
                <MDBox mt={3}>
                  <Grid container alignItems='center'>
                    <Grid item lg={5}>
                      <PieChart
                        chart={{
                          ...chartPie.chart,
                          options: {
                            plugins: {
                              tooltip: {
                                callbacks: {
                                  label: function (context) {
                                    const profitPercent = Number(context.parsed).toFixed(2);
                                    const saleAmount =
                                      chartPie.sale_amount?.[context.dataIndex] || 0;

                                    return [
                                      `กำไร: ${profitPercent}%`,
                                      `ยอดขาย: ${saleAmount.toLocaleString('th-TH', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })} บาท`,
                                    ];
                                  },
                                },
                              },
                            },
                          },
                        }}
                        height='12.5rem'
                      />
                    </Grid>
                    <Grid item lg={7}>
                      {chartPie.chart.labels.map((label, index) => (
                        <MDBox pr={1} mb={1}>
                          <MDBadgeDot
                            color={chartPie.chart.datasets.backgroundColors[index % 4]}
                            size='sm'
                            badgeContent={label}
                          />

                          <MDBox sx={{ ml: 5, mt: 0.5 }}>
                            <Grid container spacing={1}>
                              <Grid item lg={6}>
                                <MDTypography
                                  variant='button'
                                  color='black'
                                  sx={{ lineHeight: 1.2 }}
                                >
                                  ยอดขาย:
                                </MDTypography>
                                <MDTypography
                                  variant='button'
                                  color='black'
                                  fontWeight='bold'
                                  sx={{ lineHeight: 1.2 }}
                                >
                                  &nbsp; {Func.numberDisplay(chartPie.sale_amount?.[index] || 0)}{' '}
                                  บาท &nbsp; ({chartPie.chart.datasets?.data?.[index] || 0} %)
                                </MDTypography>
                              </Grid>

                              <Grid item lg={6}>
                                <MDTypography
                                  variant='button'
                                  color='black'
                                  sx={{ lineHeight: 1.2 }}
                                >
                                  กำไร:
                                </MDTypography>
                                <MDTypography
                                  variant='button'
                                  color='black'
                                  fontWeight='bold'
                                  sx={{ lineHeight: 1.2 }}
                                >
                                  &nbsp; {Func.numberDisplay(chartPie.profit_amount?.[index] || 0)}{' '}
                                  บาท &nbsp; ({chartPie.profit_percent?.[index] || 0} %)
                                </MDTypography>
                              </Grid>
                            </Grid>
                          </MDBox>
                        </MDBox>
                      ))}
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, []);

  return (
    <DashboardLayout>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
      <Navbar route={[t(`menu.dashboard`), t(`menu.dashboard_sale_profit`)]} />
      <MDBox>
        {renderSearch()}
        {renderChart()}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardSaleProfit;
